var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('navigation-bar',{staticClass:"no-print"}),_c('v-main',[_c('router-view')],1),_c('v-footer',{staticClass:"no-print"},[_c('span',[_vm._v("© 2018")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }